module.exports = __webpack_public_path__ + "media/Spira_logo_anim.3cd2435d.webm";